const processENV = process.env;
const serverURL = processENV.REACT_APP_API_URL || "/api/";
// const serverURL = "http://localhost:8383";
const basePath = processENV.REACT_APP_BASE_URL || "/";
const s3Url = processENV.REACT_APP_S3_URL || "";
export const ImageBaseUrl= "";
export const KEY_STRING = "levCLAguELVsWgvtvF20";

export const apiConfig = {
  baseURL: `${serverURL}/api/`,
  serverURL,
  timeout: 3000000,
  basePath,
  imageUrl : `${ImageBaseUrl}`,
  s3Url
};

export const IMAGE_COUNT = 4;
